
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import MultiSelect from "primevue/multiselect";

export default {
  components: {
    MultiSelect,
  },
  props: ["data"],
  setup(props, { emit }) {
    const brands: any = ref(props.data);
    const store = useStore();
    store.dispatch(Actions.BRAND_LIST);
    const brandList = computed(() => store.state.BrandModule.brand.value || []);

    const onChange = (args) => {
      emit("changeBrand", args);
    };
    return { brands, store, brandList, onChange };
  },
};
